import React from 'react';
import { Table } from 'semantic-ui-react';

// Components
import TimesheetEntryDate from './components/TimesheetEntryDate';
import TimesheetEntryEarnings from './components/TimesheetEntryEarnings';
import TimesheetEntryEffectiveRate from './components/TimesheetEntryEffectiveRate';
import TimesheetEntryEndTime from './components/TimesheetEntryEndTime';
import TimesheetEntryEntityName from './components/TimesheetEntryEntityName';
import TimesheetEntryLastReviewIsApproved from './components/TimesheetEntryLastReviewIsApproved';
import TimesheetEntryPaidBreakMinutes from './components/TimesheetEntryPaidBreakMinutes';
import TimesheetEntryPersonFirstName from './components/TimesheetEntryPersonFirstName';
import TimesheetEntryPersonLastName from './components/TimesheetEntryPersonLastName';
import TimesheetEntryRate from './components/TimesheetEntryRate';
import TimesheetEntryStartTime from './components/TimesheetEntryStartTime';
import TimesheetEntryTableRowLink from './components/TimesheetEntryTableRowLink';
import TimesheetEntryPaidBreakDollars from './components/TimesheetEntryPaidBreakDollars';
import TimesheetEntryTotalPaidMinutes from './components/TimesheetEntryTotalPaidMinutes';
import TimesheetEntryUnits from './components/TimesheetEntryUnits';
import TimesheetEntryUnpaidBreakMinutes from './components/TimesheetEntryUnpaidBreakMinutes';
import TimesheetEntryWorkTypeName from './components/TimesheetEntryWorkTypeName';

interface Props {
    timesheetEntryUuid?: number;
}

export default class TimesheetEntriesTableRow extends React.PureComponent<Props> {
    render() {
        const { timesheetEntryUuid } = this.props;
        if (!timesheetEntryUuid) return null;
        return (
            <TimesheetEntryTableRowLink timesheetEntryUuid={timesheetEntryUuid}>
                <Table.Cell>
                    <TimesheetEntryDate
                        timesheetEntryUuid={timesheetEntryUuid}
                    />
                </Table.Cell>
                <Table.Cell>
                    <TimesheetEntryPersonFirstName
                        timesheetEntryUuid={timesheetEntryUuid}
                    />
                </Table.Cell>
                <Table.Cell>
                    <TimesheetEntryPersonLastName
                        timesheetEntryUuid={timesheetEntryUuid}
                    />
                </Table.Cell>
                <Table.Cell>
                    <TimesheetEntryWorkTypeName
                        timesheetEntryUuid={timesheetEntryUuid}
                    />
                </Table.Cell>
                <Table.Cell>
                    <TimesheetEntryEntityName
                        timesheetEntryUuid={timesheetEntryUuid}
                    />
                </Table.Cell>
                <Table.Cell>
                    <TimesheetEntryStartTime
                        timesheetEntryUuid={timesheetEntryUuid}
                    />
                </Table.Cell>
                <Table.Cell>
                    <TimesheetEntryEndTime
                        timesheetEntryUuid={timesheetEntryUuid}
                    />
                </Table.Cell>
                <Table.Cell>
                    <TimesheetEntryUnpaidBreakMinutes
                        timesheetEntryUuid={timesheetEntryUuid}
                    />
                </Table.Cell>
                <Table.Cell>
                    <TimesheetEntryPaidBreakMinutes
                        timesheetEntryUuid={timesheetEntryUuid}
                    />
                </Table.Cell>
                <Table.Cell>
                    <TimesheetEntryTotalPaidMinutes
                        timesheetEntryUuid={timesheetEntryUuid}
                    />
                </Table.Cell>
                <Table.Cell>
                    <TimesheetEntryUnits
                        timesheetEntryUuid={timesheetEntryUuid}
                    />
                </Table.Cell>
                <Table.Cell>
                    <TimesheetEntryRate
                        timesheetEntryUuid={timesheetEntryUuid}
                    />
                </Table.Cell>
                <Table.Cell>
                    <TimesheetEntryEarnings
                        timesheetEntryUuid={timesheetEntryUuid}
                    />
                </Table.Cell>
                <Table.Cell>
                    <TimesheetEntryEffectiveRate
                        timesheetEntryUuid={timesheetEntryUuid}
                    />
                </Table.Cell>
                <Table.Cell>
                    <TimesheetEntryPaidBreakDollars
                        timesheetEntryUuid={timesheetEntryUuid}
                    />
                </Table.Cell>
                <Table.Cell>
                    <TimesheetEntryLastReviewIsApproved
                        timesheetEntryUuid={timesheetEntryUuid}
                    />
                </Table.Cell>
            </TimesheetEntryTableRowLink>
        );
    }
}
